import script from "./BellButton.vue?vue&type=script&setup=true&lang=js"
export * from "./BellButton.vue?vue&type=script&setup=true&lang=js"

import "./BellButton.vue?vue&type=style&index=0&id=6de71daa&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6de71daa"]])

export default __exports__